import { render, staticRenderFns } from "./SortFormat.vue?vue&type=template&id=1c8f1940&lang=pug"
import script from "./SortFormat.vue?vue&type=script&lang=js"
export * from "./SortFormat.vue?vue&type=script&lang=js"
import style0 from "./SortFormat.vue?vue&type=style&index=0&id=1c8f1940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports